module.exports = __webpack_public_path__ + "assets/img/2.2fe5c598.jpg";